/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _button_to_like_fr = new IntlMessageFormat([{ type: 0, value: "J'aime" }], 'fr');

export function button_to_like(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _button_to_like_fr.format(args) as unknown as string;
    }

    return _button_to_like_fr.format(args) as unknown as string;
}

const _button_to_comment_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Commenter' }],
    'fr',
);

export function button_to_comment(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _button_to_comment_fr.format(args) as unknown as string;
    }

    return _button_to_comment_fr.format(args) as unknown as string;
}

const _button_favorites_fr = new IntlMessageFormat([{ type: 0, value: 'Favoris' }], 'fr');

export function button_favorites(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _button_favorites_fr.format(args) as unknown as string;
    }

    return _button_favorites_fr.format(args) as unknown as string;
}

const _button_to_share_fr = new IntlMessageFormat([{ type: 0, value: 'Partager' }], 'fr');

export function button_to_share(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _button_to_share_fr.format(args) as unknown as string;
    }

    return _button_to_share_fr.format(args) as unknown as string;
}

const _comment_button_reply_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Répondre' }],
    'fr',
);

export function comment_button_reply(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _comment_button_reply_fr.format(args) as unknown as string;
    }

    return _comment_button_reply_fr.format(args) as unknown as string;
}

const _menu_edit_the_post_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Éditer le post' }],
    'fr',
);

export function menu_edit_the_post(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu_edit_the_post_fr.format(args) as unknown as string;
    }

    return _menu_edit_the_post_fr.format(args) as unknown as string;
}

const _menu_delete_the_post_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Supprimer le post' }],
    'fr',
);

export function menu_delete_the_post(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu_delete_the_post_fr.format(args) as unknown as string;
    }

    return _menu_delete_the_post_fr.format(args) as unknown as string;
}

const _menu_signal_the_post_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Signaler le post' }],
    'fr',
);

export function menu_signal_the_post(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _menu_signal_the_post_fr.format(args) as unknown as string;
    }

    return _menu_signal_the_post_fr.format(args) as unknown as string;
}

const _modal_edit_post_title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Éditer le post' }],
    'fr',
);

export function modal_edit_post_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _modal_edit_post_title_fr.format(args) as unknown as string;
    }

    return _modal_edit_post_title_fr.format(args) as unknown as string;
}

const _commented_fr = new IntlMessageFormat([{ type: 0, value: 'a commenté' }], 'fr');

export function commented(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _commented_fr.format(args) as unknown as string;
    }

    return _commented_fr.format(args) as unknown as string;
}

const _reacted_fr = new IntlMessageFormat([{ type: 0, value: 'a réagi' }], 'fr');

export function reacted(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _reacted_fr.format(args) as unknown as string;
    }

    return _reacted_fr.format(args) as unknown as string;
}

const _shared_fr = new IntlMessageFormat([{ type: 0, value: 'a partagé' }], 'fr');

export function shared(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _shared_fr.format(args) as unknown as string;
    }

    return _shared_fr.format(args) as unknown as string;
}

const _x_reacted_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'nb',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' personne a réagi' }] },
                other: {
                    value: [{ type: 7 }, { type: 0, value: ' personnes ont réagi' }],
                },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

export function x_reacted(args: { nb: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_reacted_fr.format(args) as unknown as string;
    }

    return _x_reacted_fr.format(args) as unknown as string;
}

const _share_on_my_profile_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Partager sur mon profil' }],
    'fr',
);

export function share_on_my_profile(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _share_on_my_profile_fr.format(args) as unknown as string;
    }

    return _share_on_my_profile_fr.format(args) as unknown as string;
}

const _default_share_text_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Découvrez ce post sur GoAfrica Online' }],
    'fr',
);

export function default_share_text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _default_share_text_fr.format(args) as unknown as string;
    }

    return _default_share_text_fr.format(args) as unknown as string;
}

const _link_copied_to_clipboard_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Lien du post copié dans le presse-papier' }],
    'fr',
);

export function link_copied_to_clipboard(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _link_copied_to_clipboard_fr.format(args) as unknown as string;
    }

    return _link_copied_to_clipboard_fr.format(args) as unknown as string;
}

const _confirm_modal_delete_post_message_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voulez-vous vraiment supprimer ce post ?' }],
    'fr',
);

export function confirm_modal_delete_post_message(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _confirm_modal_delete_post_message_fr.format(args) as unknown as string;
    }

    return _confirm_modal_delete_post_message_fr.format(args) as unknown as string;
}

const _toast_comment_saved_success_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Commentaire enregistré avec succès' }],
    'fr',
);

export function toast_comment_saved_success(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _toast_comment_saved_success_fr.format(args) as unknown as string;
    }

    return _toast_comment_saved_success_fr.format(args) as unknown as string;
}

const _toast_post_saved_success_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Post enregistré avec succès' }],
    'fr',
);

export function toast_post_saved_success(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _toast_post_saved_success_fr.format(args) as unknown as string;
    }

    return _toast_post_saved_success_fr.format(args) as unknown as string;
}

const _x_comments_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'nb',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' commentaire' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' commentaires' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

export function x_comments(args: { nb: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_comments_fr.format(args) as unknown as string;
    }

    return _x_comments_fr.format(args) as unknown as string;
}

const _x_replies_fr = new IntlMessageFormat(
    [
        {
            type: 6,
            value: 'nb',
            options: {
                one: { value: [{ type: 7 }, { type: 0, value: ' réponse' }] },
                other: { value: [{ type: 7 }, { type: 0, value: ' réponses' }] },
            },
            offset: 0,
            pluralType: 'cardinal',
        },
    ],
    'fr',
);

export function x_replies(args: { nb: number }, lang: string): string {
    if (lang.startsWith('fr')) {
        return _x_replies_fr.format(args) as unknown as string;
    }

    return _x_replies_fr.format(args) as unknown as string;
}

const _see_less_fr = new IntlMessageFormat([{ type: 0, value: '...voir moins' }], 'fr');

export function see_less(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _see_less_fr.format(args) as unknown as string;
    }

    return _see_less_fr.format(args) as unknown as string;
}

const _see_more_fr = new IntlMessageFormat([{ type: 0, value: '...voir plus' }], 'fr');

export function see_more(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _see_more_fr.format(args) as unknown as string;
    }

    return _see_more_fr.format(args) as unknown as string;
}

const _see_more_replies_fr = new IntlMessageFormat(
    [{ type: 0, value: '...voir plus de réponses' }],
    'fr',
);

export function see_more_replies(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _see_more_replies_fr.format(args) as unknown as string;
    }

    return _see_more_replies_fr.format(args) as unknown as string;
}

const _see_more_comments_fr = new IntlMessageFormat(
    [{ type: 0, value: '...voir plus de commentaires' }],
    'fr',
);

export function see_more_comments(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _see_more_comments_fr.format(args) as unknown as string;
    }

    return _see_more_comments_fr.format(args) as unknown as string;
}

const _bookmark_default_name_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Défaut' }],
    'fr',
);

export function bookmark_default_name(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _bookmark_default_name_fr.format(args) as unknown as string;
    }

    return _bookmark_default_name_fr.format(args) as unknown as string;
}

const _bookmark_section_title_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Favoris' }],
    'fr',
);

export function bookmark_section_title(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _bookmark_section_title_fr.format(args) as unknown as string;
    }

    return _bookmark_section_title_fr.format(args) as unknown as string;
}

const _bookmark_section_see_all_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voir tout' }],
    'fr',
);

export function bookmark_section_see_all(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _bookmark_section_see_all_fr.format(args) as unknown as string;
    }

    return _bookmark_section_see_all_fr.format(args) as unknown as string;
}

const _bookmark_section_not_found_text_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Commencez à mettre des posts en favoris et à créer vos dossiers personnalisés',
        },
    ],
    'fr',
);

export function bookmark_section_not_found_text(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _bookmark_section_not_found_text_fr.format(args) as unknown as string;
    }

    return _bookmark_section_not_found_text_fr.format(args) as unknown as string;
}

const _input_video_placeholder_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Lien Youtube/Vimeo' }],
    'fr',
);

export function input_video_placeholder(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _input_video_placeholder_fr.format(args) as unknown as string;
    }

    return _input_video_placeholder_fr.format(args) as unknown as string;
}

const _input_video_label_fr = new IntlMessageFormat([{ type: 0, value: 'Vidéo' }], 'fr');

export function input_video_label(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _input_video_label_fr.format(args) as unknown as string;
    }

    return _input_video_label_fr.format(args) as unknown as string;
}

const _input_photo_label_fr = new IntlMessageFormat([{ type: 0, value: 'Photo' }], 'fr');

export function input_photo_label(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _input_photo_label_fr.format(args) as unknown as string;
    }

    return _input_photo_label_fr.format(args) as unknown as string;
}

const _tag_info_fr = new IntlMessageFormat([{ type: 0, value: 'Information' }], 'fr');

export function tag_info(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _tag_info_fr.format(args) as unknown as string;
    }

    return _tag_info_fr.format(args) as unknown as string;
}

const _tag_product_or_service_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Produit / Service' }],
    'fr',
);

export function tag_product_or_service(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _tag_product_or_service_fr.format(args) as unknown as string;
    }

    return _tag_product_or_service_fr.format(args) as unknown as string;
}

const _tag_promo_fr = new IntlMessageFormat([{ type: 0, value: 'Promotion' }], 'fr');

export function tag_promo(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _tag_promo_fr.format(args) as unknown as string;
    }

    return _tag_promo_fr.format(args) as unknown as string;
}

const _tag_job_fr = new IntlMessageFormat([{ type: 0, value: 'Emploi' }], 'fr');

export function tag_job(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _tag_job_fr.format(args) as unknown as string;
    }

    return _tag_job_fr.format(args) as unknown as string;
}

const _tag_event_fr = new IntlMessageFormat([{ type: 0, value: 'Événement' }], 'fr');

export function tag_event(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _tag_event_fr.format(args) as unknown as string;
    }

    return _tag_event_fr.format(args) as unknown as string;
}

const _category_product_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Produits' }],
    'fr',
);

export function category_product(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_product_fr.format(args) as unknown as string;
    }

    return _category_product_fr.format(args) as unknown as string;
}

const _category_service_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Services' }],
    'fr',
);

export function category_service(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_service_fr.format(args) as unknown as string;
    }

    return _category_service_fr.format(args) as unknown as string;
}

const _category_training_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Formations' }],
    'fr',
);

export function category_training(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_training_fr.format(args) as unknown as string;
    }

    return _category_training_fr.format(args) as unknown as string;
}

const _category_vehicle_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Véhicules' }],
    'fr',
);

export function category_vehicle(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_vehicle_fr.format(args) as unknown as string;
    }

    return _category_vehicle_fr.format(args) as unknown as string;
}

const _category_professional_equipment_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Matériel professionnel' }],
    'fr',
);

export function category_professional_equipment(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_professional_equipment_fr.format(args) as unknown as string;
    }

    return _category_professional_equipment_fr.format(args) as unknown as string;
}

const _category_classifieds_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Petites annonces' }],
    'fr',
);

export function category_classifieds(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_classifieds_fr.format(args) as unknown as string;
    }

    return _category_classifieds_fr.format(args) as unknown as string;
}

const _category_event_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Evénements' }],
    'fr',
);

export function category_event(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_event_fr.format(args) as unknown as string;
    }

    return _category_event_fr.format(args) as unknown as string;
}

const _category_job_fr = new IntlMessageFormat([{ type: 0, value: 'Emploi' }], 'fr');

export function category_job(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_job_fr.format(args) as unknown as string;
    }

    return _category_job_fr.format(args) as unknown as string;
}

const _category_info_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Informations' }],
    'fr',
);

export function category_info(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_info_fr.format(args) as unknown as string;
    }

    return _category_info_fr.format(args) as unknown as string;
}

const _category_promo_fr = new IntlMessageFormat([{ type: 0, value: 'Promotion' }], 'fr');

export function category_promo(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_promo_fr.format(args) as unknown as string;
    }

    return _category_promo_fr.format(args) as unknown as string;
}

const _category_real_estate_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Immobilier' }],
    'fr',
);

export function category_real_estate(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_real_estate_fr.format(args) as unknown as string;
    }

    return _category_real_estate_fr.format(args) as unknown as string;
}

const _category_real_estate_sales_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ventes immobilières' }],
    'fr',
);

export function category_real_estate_sales(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_real_estate_sales_fr.format(args) as unknown as string;
    }

    return _category_real_estate_sales_fr.format(args) as unknown as string;
}

const _category_real_estate_new_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Immobilier neuf' }],
    'fr',
);

export function category_real_estate_new(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_real_estate_new_fr.format(args) as unknown as string;
    }

    return _category_real_estate_new_fr.format(args) as unknown as string;
}

const _category_real_estate_rentals_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Locations' }],
    'fr',
);

export function category_real_estate_rentals(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_real_estate_rentals_fr.format(args) as unknown as string;
    }

    return _category_real_estate_rentals_fr.format(args) as unknown as string;
}

const _category_real_estate_roommates_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Colocations' }],
    'fr',
);

export function category_real_estate_roommates(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_real_estate_roommates_fr.format(args) as unknown as string;
    }

    return _category_real_estate_roommates_fr.format(args) as unknown as string;
}

const _category_real_estate_offices_and_shops_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Bureaux et commerces' }],
    'fr',
);

export function category_real_estate_offices_and_shops(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _category_real_estate_offices_and_shops_fr.format(
            args,
        ) as unknown as string;
    }

    return _category_real_estate_offices_and_shops_fr.format(args) as unknown as string;
}

const _select_tag_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'tag',
            options: {
                info: { value: [{ type: 0, value: 'Information' }] },
                product_or_service: { value: [{ type: 0, value: 'Produit / Service' }] },
                promo: { value: [{ type: 0, value: 'Promotion' }] },
                job: { value: [{ type: 0, value: 'Emploi' }] },
                event: { value: [{ type: 0, value: 'Événement' }] },
                service: { value: [{ type: 0, value: 'Service' }] },
                training: { value: [{ type: 0, value: 'Formation' }] },
                product: { value: [{ type: 0, value: 'Produit' }] },
                product__computer_science: {
                    value: [{ type: 0, value: 'Informatique' }],
                },
                product__phones_and_tablets: {
                    value: [{ type: 0, value: 'Téléphones & Tablettes' }],
                },
                product__tv_and_hi_tech: { value: [{ type: 0, value: 'TV & Hi tech' }] },
                product__home_and_kitchen: {
                    value: [{ type: 0, value: 'Maison et cuisine' }],
                },
                product__furniture_an_doffice: {
                    value: [{ type: 0, value: 'Mobilier & Bureau' }],
                },
                product__home_appliance: {
                    value: [{ type: 0, value: 'Electroménager' }],
                },
                product__clothing_and_shoes: {
                    value: [{ type: 0, value: 'Vêtements et chaussures' }],
                },
                product__beauty_andhealth: {
                    value: [{ type: 0, value: 'Beauté & Santé' }],
                },
                product__video_games_and_consoles: {
                    value: [{ type: 0, value: 'Jeux vidéos & consoles' }],
                },
                product__sports_and_leisure: {
                    value: [{ type: 0, value: 'Sports & loisirs' }],
                },
                product__baby_and_toys: { value: [{ type: 0, value: 'Bébé & jouets' }] },
                product__garden_and_animals_and_outdoors: {
                    value: [{ type: 0, value: 'Jardin - Animaux - Plein air' }],
                },
                classifieds: { value: [{ type: 0, value: 'Petites annonces' }] },
                vehicle: { value: [{ type: 0, value: 'Véhicule' }] },
                vehicle__cars: { value: [{ type: 0, value: 'Voitures' }] },
                vehicle__motorcycles: { value: [{ type: 0, value: 'Motos' }] },
                vehicle__trucks: { value: [{ type: 0, value: 'Camions' }] },
                vehicle__utilities: { value: [{ type: 0, value: 'Utilitaires' }] },
                vehicle__boats_boating: {
                    value: [{ type: 0, value: 'Bateaux / Nautisme' }],
                },
                real_estate: { value: [{ type: 0, value: 'Immobilier' }] },
                real_estate_sales: { value: [{ type: 0, value: 'Ventes immobilières' }] },
                real_estate_new: { value: [{ type: 0, value: 'Immobilier neuf' }] },
                real_estate_rentals: { value: [{ type: 0, value: 'Location' }] },
                real_estate_roommates: { value: [{ type: 0, value: 'Colocation' }] },
                real_estate_offices_and_shops: {
                    value: [{ type: 0, value: 'Bureaux et commerces' }],
                },
                professional_equipment: {
                    value: [{ type: 0, value: 'Matériel professionnel' }],
                },
                professional_equipment__tractors: {
                    value: [{ type: 0, value: 'Tracteurs' }],
                },
                professional_equipment__agricultural_material: {
                    value: [{ type: 0, value: 'Matériel agricole' }],
                },
                professional_equipment__construction_structural_work: {
                    value: [{ type: 0, value: 'BTP - Gros oeuvre' }],
                },
                professional_equipment__heavyweight: {
                    value: [{ type: 0, value: 'Poids lourds' }],
                },
                professional_equipment__lifting_equipment: {
                    value: [{ type: 0, value: 'Matériel de levage' }],
                },
                professional_equipment__industrial_equipment: {
                    value: [{ type: 0, value: 'Equipements industriels' }],
                },
                professional_equipment__equipment_for_restaurants_and_hotels: {
                    value: [{ type: 0, value: 'Équipements pour restaurants et hôtels' }],
                },
                professional_equipment__equipment_for_businesses: {
                    value: [{ type: 0, value: 'Equipements pour commerces' }],
                },
                professional_equipment__medical_equipment: {
                    value: [{ type: 0, value: 'Equipements médicaux' }],
                },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
    ],
    'fr',
);

export function select_tag(
    args: {
        tag:
            | 'classifieds'
            | 'event'
            | 'info'
            | 'job'
            | 'product'
            | 'product__baby_and_toys'
            | 'product__beauty_andhealth'
            | 'product__clothing_and_shoes'
            | 'product__computer_science'
            | 'product__furniture_an_doffice'
            | 'product__garden_and_animals_and_outdoors'
            | 'product__home_and_kitchen'
            | 'product__home_appliance'
            | 'product__phones_and_tablets'
            | 'product__sports_and_leisure'
            | 'product__tv_and_hi_tech'
            | 'product__video_games_and_consoles'
            | 'product_or_service'
            | 'professional_equipment'
            | 'professional_equipment__agricultural_material'
            | 'professional_equipment__construction_structural_work'
            | 'professional_equipment__equipment_for_businesses'
            | 'professional_equipment__equipment_for_restaurants_and_hotels'
            | 'professional_equipment__heavyweight'
            | 'professional_equipment__industrial_equipment'
            | 'professional_equipment__lifting_equipment'
            | 'professional_equipment__medical_equipment'
            | 'professional_equipment__tractors'
            | 'promo'
            | 'real_estate'
            | 'real_estate_new'
            | 'real_estate_offices_and_shops'
            | 'real_estate_rentals'
            | 'real_estate_roommates'
            | 'real_estate_sales'
            | 'service'
            | 'training'
            | 'vehicle'
            | 'vehicle__boats_boating'
            | 'vehicle__cars'
            | 'vehicle__motorcycles'
            | 'vehicle__trucks'
            | 'vehicle__utilities';
    },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _select_tag_fr.format(args) as unknown as string;
    }

    return _select_tag_fr.format(args) as unknown as string;
}

const _toast_media_upload_error_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: "Une erreur est survenue lors de l'envoi des médias, veuillez réessayer.",
        },
    ],
    'fr',
);

export function toast_media_upload_error(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _toast_media_upload_error_fr.format(args) as unknown as string;
    }

    return _toast_media_upload_error_fr.format(args) as unknown as string;
}

const _discussion_in_category_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Ceci est une discussion dans la catégorie' }],
    'fr',
);

export function discussion_in_category(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _discussion_in_category_fr.format(args) as unknown as string;
    }

    return _discussion_in_category_fr.format(args) as unknown as string;
}

const _see_discussion_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Voir les discussions' }],
    'fr',
);

export function see_discussion(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _see_discussion_fr.format(args) as unknown as string;
    }

    return _see_discussion_fr.format(args) as unknown as string;
}

const _discussion_in_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Discussions dans' }],
    'fr',
);

export function discussion_in(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _discussion_in_fr.format(args) as unknown as string;
    }

    return _discussion_in_fr.format(args) as unknown as string;
}

const _see_all_fr = new IntlMessageFormat([{ type: 0, value: 'Voir tout' }], 'fr');

export function see_all(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _see_all_fr.format(args) as unknown as string;
    }

    return _see_all_fr.format(args) as unknown as string;
}

const _no_discussion_for_now_fr = new IntlMessageFormat(
    [
        {
            type: 0,
            value: 'Aucune discussion pour le moment, soyez le premier à lancer un sujet!',
        },
    ],
    'fr',
);

export function no_discussion_for_now(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _no_discussion_for_now_fr.format(args) as unknown as string;
    }

    return _no_discussion_for_now_fr.format(args) as unknown as string;
}

const _join_discussion_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Rejoignez gratuitement la discussion, exprimez-vous' }],
    'fr',
);

export function join_discussion(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _join_discussion_fr.format(args) as unknown as string;
    }

    return _join_discussion_fr.format(args) as unknown as string;
}

const _publish_from_fr = new IntlMessageFormat(
    [{ type: 0, value: 'Publier depuis' }],
    'fr',
);

export function publish_from(
    args: Record<string, never> | undefined = undefined,
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _publish_from_fr.format(args) as unknown as string;
    }

    return _publish_from_fr.format(args) as unknown as string;
}
